import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fileService } from '../services/fileService';

export function useFileComments(fileId: string) {
  return useQuery({
    queryKey: ['file-comments', fileId],
    queryFn: () => fileService.getComments(fileId),
    enabled: !!fileId,
  });
}

export function useCreateComment(fileId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (content: string) => fileService.createComment(fileId, content),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['file-comments', fileId] });
    },
  });
}

export function useDeleteComment(fileId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (commentId: string) => fileService.deleteComment(fileId, commentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['file-comments', fileId] });
    },
  });
}
